import { render, staticRenderFns } from "./moneyBack_claim.vue?vue&type=template&id=1a4854bc"
import script from "./moneyBack_claim.vue?vue&type=script&lang=js"
export * from "./moneyBack_claim.vue?vue&type=script&lang=js"
import style0 from "./moneyBack_claim.vue?vue&type=style&index=0&id=1a4854bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports